import { ReactNode } from 'react';
import Config from '../../config.json';

const FEATURE_FLAGS = {
  SSO:
    process.env.REACT_APP_FEATURE_TOGGLE_SSO === 'true' ||
    Config.REACT_APP_FEATURE_TOGGLE_SSO === 'true'
} as const;

export function getToggle(toggleName: keyof typeof FEATURE_FLAGS) {
  return FEATURE_FLAGS[toggleName] ?? false;
}

interface ToggledProps {
  readonly childrenWhenTrue: ReactNode;
  readonly childrenWhenFalse?: ReactNode;
  readonly isEnabled: boolean;
}

export function Toggled({
  isEnabled,
  childrenWhenTrue,
  childrenWhenFalse = null
}: ToggledProps) {
  return isEnabled ? <>{childrenWhenTrue}</> : <>{childrenWhenFalse}</>;
}
